import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, deleteVariableCategoryValues } from 'store/data/variables';

type HandlerInput = Parameters<typeof deleteVariableCategoryValues>[0];

export function useDeleteVariableCategoryValues(): Operation<(input: HandlerInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(
		ActionTypes.DELETE_VARIABLE_CATEGORY_VALUES
	);

	function handler(input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(deleteVariableCategoryValues(input));
	}

	return [{ loading, error }, handler];
}
